import { Container, Eyebrow } from '@nexa/ui';
import { useCopy } from '@/core/i18n';

/**
 * Dải logo khách hàng — section duy nhất của trang KHÔNG dùng `Section`.
 *
 * Thiết kế cho nó nhịp dọc riêng (36px trên, 8px dưới — `template.html` dòng 776) chứ không phải
 * `--spacing-section` (56 đến 96px), vì nó là phần đuôi của hero chứ không phải một section độc
 * lập: không tiêu đề, không id, nav không theo dõi nó. Nhồi vào `Section` thì phải thêm bậc `size`
 * thứ ba vào `packages/ui` — đắt hơn hẳn một thẻ section trần. Padding NGANG vẫn do `Container`
 * lo (`--spacing-gutter` 20 đến 32px), nên chỗ này chỉ khai nhịp dọc.
 *
 * Ba hộp là placeholder dashed CÓ CHỦ Ý (nợ số 2, design doc §13), không phải chỗ chưa xong.
 * KHÔNG đặt `aria-hidden`: dòng chú thích ngay dưới nói rõ tên khách hàng sẽ bổ sung sau, nên
 * thông tin này có nghĩa với người dùng screen reader.
 *
 * Hai cỡ chữ ở đây KHÁC NHAU và đó là chủ ý của thiết kế, không phải sơ suất: nhãn trong hộp
 * 12.5px, dòng chú thích 11.5px. Tra bảng thang chữ (`reference.md` §4.1) ra hai token khác nhau.
 * Dòng chú thích không dùng `Text` vì `Text` không có bậc 11.5px, và thêm bậc vào nó là sửa
 * `packages/ui`.
 *
 * Nợ a11y ĐÃ BIẾT, giữ nguyên có chủ ý: `ink-alt-300` trên nền trắng đo được 2.61:1, trượt cả
 * ngưỡng 3:1 (`reference.md` §5). Luật 5 của skill — trung thành thiết kế đứng trên WCAG, và đây
 * là quyết định của user chứ không phải của người viết section này.
 */
export function SocialProofSection() {
  const copy = useCopy();

  return (
    <section className="bg-surface pt-9 pb-2">
      <Container width="content" className="text-center">
        <Eyebrow tone="neutral">{copy.socialProof.eyebrow}</Eyebrow>

        <div className="mt-[22px] flex flex-wrap justify-center gap-[18px]">
          {copy.socialProof.logos.map((label) => (
            <div
              key={label}
              className="grid h-16 w-[230px] place-items-center rounded-card-sm border border-dashed border-ink-300 text-caption text-ink-alt-300"
            >
              {label}
            </div>
          ))}
        </div>

        <p className="mt-3 text-eyebrow text-ink-alt-300">{copy.socialProof.note}</p>
      </Container>
    </section>
  );
}
